module.exports = __webpack_public_path__ + "img/minion_reminder_thumb.c3f4da90.jpg";